import React, { useEffect, useState } from 'react';
import './ImportData.scss';
import { withTranslation } from 'react-i18next';
import { BiSolidCheckSquare } from "react-icons/bi";
import ImportFile from './ImportFile';
import ExportFile from './ExportFile';
import useHasPermission from '../../../core/hooks/useHasPermission';

const ImportData = ({ t }) => {

    const [showExport, setShowExport] = useState(true);
    const [showImport, setShowImport] = useState(false);
    const { hasDataCollectionUpdatePermission } = useHasPermission();

    return (
        <div className='ImportData_Box'>
            <div className="List_header">
                <h5 className="MH">{t("ImportData.label")}</h5>
            </div>
            <div className='ImportData_Box_head row mx-0'>

                <div className='col-md-12 ImportData_Box_head_inner'>
                    <ul>
                        <li className={`${showExport ? 'active' : ''} cursor`} onClick={() => { setShowImport(false); setShowExport(true) }}>
                            <div className='box'>1</div>
                            <BiSolidCheckSquare />
                            {t("DownloadTemplate.label")}
                        </li>
                        <li className={`${showImport ? 'active' : ''} cursor`} 
                        hidden={!hasDataCollectionUpdatePermission()}
                        onClick={() => { setShowImport(true); setShowExport(false) }}>
                            <div className='box'>2</div>
                            <BiSolidCheckSquare />
                            {t("UploadFile.label")}
                        </li>
                        {/* <li>
                            <div className='box'>3</div>
                            <BiSolidCheckSquare />
                            Verify
                        </li> */}
                    </ul>
                </div>
                {/* <div className='col-md-3'>
                        <ul>
                            <li>
                            <Button variant='secondary' className='px-3'>Back</Button>
                            </li>
                            <li>
                            <Button variant='primary' className='px-3'>Skip</Button>
                            </li>
                        </ul>
                </div> */}
            </div>
            <div className='ImportData_Box_body'>
                {
                    showExport &&
                    <div className='Download_templateView'>
                        <ExportFile />
                    </div>
                }

                {
                    showImport &&
                    <div className='ImportData_UploadBox'>
                        <ImportFile />
                    </div>
                }

                {/* <div className='Verify_dataBox '>
                    <Table bordered >
                        <thead>
                        <tr>
                            <th>Month</th>
                            <th>Year</th>
                            <th>Topic</th>
                            <th>Metric Name</th>
                            <th>Metric Code</th>
                            <th>Datapoint Name</th>
                            <th>Datapoint Code</th>
                            <th>Greenpar</th>
                            <th>UOM </th>
                            <th>Attachments</th>
                            <th>Comments</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>January</td>
                            <td>2023</td>
                            <td>Employment</td>
                            <td>New employee hires</td>
                            <td>ECD022</td>
                            <td>Employees younger than 30 year old</td>
                            <td>DP022a</td>
                            <td>1.00</td>
                            <td>no.</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>January</td>
                            <td>2023</td>
                            <td>Employment</td>
                            <td>New employee hires</td>
                            <td>ECD022</td>
                            <td>Employees younger than 30 year old</td>
                            <td>DP022a</td>
                            <td>1.00</td>
                            <td>no.</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>January</td>
                            <td>2023</td>
                            <td>Employment</td>
                            <td>New employee hires</td>
                            <td>ECD022</td>
                            <td>Employees younger than 30 year old</td>
                            <td>DP022a</td>
                            <td>1.00</td>
                            <td>no.</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>January</td>
                            <td>2023</td>
                            <td>Employment</td>
                            <td>New employee hires</td>
                            <td>ECD022</td>
                            <td>Employees younger than 30 year old</td>
                            <td>DP022a</td>
                            <td>1.00</td>
                            <td>no.</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>January</td>
                            <td>2023</td>
                            <td>Employment</td>
                            <td>New employee hires</td>
                            <td>ECD022</td>
                            <td>Employees younger than 30 year old</td>
                            <td>DP022a</td>
                            <td>1.00</td>
                            <td>no.</td>
                            <td></td>
                            <td></td>
                        </tr>

                        </tbody>
                    </Table>

                    <div className='text-center p-2'>
                        <Button variant='secondary' className='px-3 me-2'>Back</Button>
                        <Button variant='primary' className='px-3'>Save</Button>
                    </div>
                </div> */}

            </div>
        </div>
    );
};

export default withTranslation()(ImportData);